import React from "react"
import "../Styles/index.scss"
import Newshome from "../Components/bloginhome/newshome" 
import Articlehome from "../Components/bloginhome/articlehome" 
import Concerthome from "../Components/bloginhome/concerthome" 
const BlogShowInHome = () => {
  return (
    <div className="blogshowinhome">
      <div className="blogshowinhome-news">
        <span className="badge titles-badge"> NEWS </span>


<Newshome />


      </div>
      <div className="blogshowinhome-article">
        <span className="badge titles-badge"> ARTICLE </span>


<Articlehome />


      </div>

      <div className="blogshowinhome-concert">

      <div className="blogshowinhome-article">
        <span className="badge titles-badge"> CONCERT </span>


<Concerthome />


      </div>


      </div>
    </div>
  )
}

export default BlogShowInHome
